const incomePaymentMethods = [
  {
    value: 'cash',
    text:  'Dinheiro',
  },
  {
    value: 'direct_deposit',
    text:  'Pix / Depósito em conta corrente',
  },
  {
    value: 'other',
    text:  'Outros',
  },
];
export default incomePaymentMethods;
